/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Text } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { ButtonLink } from 'components/route'
import { useAlteracoesFenotipicasQuery } from 'graphql/hooks.generated'
import { StatusAvaliadoEnum } from 'graphql/types.generated'
import { Fragment, useMemo } from 'react'
import { useField } from 'react-final-form'
import { useRouteMatch } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import { MetaPath } from 'util/metaPath'

import { AvaliacaoDesenvolvimentoModel } from '../model'
import { avaliacaoPresenteList } from '../util/avaliacaoPresenteList'
import { AlteracaoFenotipicaModal } from './AlteracaoFenotipicaModal'

export interface AlteracoesFenotipicasModel {
  alteracoesFenotipicas: AvaliacaoDesenvolvimentoModel[]
}

interface AlteracaoFenotipicaViewProps {
  name: MetaPath<AlteracoesFenotipicasModel>
  prontuarioId: ID
}

export function AlteracaoFenotipicaView(props: AlteracaoFenotipicaViewProps) {
  const { name, prontuarioId } = props
  const match = useRouteMatch()

  const {
    input: { value, onChange },
  } = useField<AlteracoesFenotipicasModel>(name.absolutePath())

  useAlteracoesFenotipicasQuery({
    variables: {
      prontuarioId: prontuarioId,
    },
    onCompleted: (data) =>
      !value &&
      onChange({
        alteracoesFenotipicas: data?.alteracoesFenotipicas
          .map((item) => ({
            ...item,
            statusButton: item.status,
            disableButton: item.status === StatusAvaliadoEnum.PRESENTE,
          }))
          .sort((a, b) => Number(a.id) - Number(b.id)),
      }),
    skip: !!value,
  })

  const descricaoAvaliadosComoPresente = useMemo(() => avaliacaoPresenteList(value.alteracoesFenotipicas), [
    value.alteracoesFenotipicas,
  ])
  return (
    <Fragment>
      <Grid alignItems='center'>
        <Cell size={3}>
          <ButtonLink
            style={css`
              width: 100%;
              text-align: center;
            `}
            size='small'
            kind='primary'
            to={`${match.url}/puericultura/alteracao-fenotipica`}
          >
            Avaliar alterações fenotípicas
          </ButtonLink>
        </Cell>
        <Cell size={9}>
          <HLabel title='Alterações fenotípicas:'>
            {descricaoAvaliadosComoPresente || <Text fontStyle='italic'>Nenhuma alteração fenotípica presente</Text>}
          </HLabel>
        </Cell>
      </Grid>
      <Switch>
        <Route path={`${match.url}/puericultura/alteracao-fenotipica`}>
          <AlteracaoFenotipicaModal initialValues={value} updateAlteracaoFenotipica={onChange} />
        </Route>
      </Switch>
    </Fragment>
  )
}
